<template>
    <div class="setup__list">
      <p class="setup__item" v-if="!ingame">
        <span>Выберите текст:</span>
        <v-select 
          @input="onSelectText"
          label="text" 
          :options="textsData" 
          v-model="params.text_id" 
          :reduce="option => option.id"
          :clearable="false"
          @search:focus="scrollToSelectedText"
          ref="select"
      >
          <template slot="option" slot-scope="option">
            <div class="d-center" v-html="option.html"></div>
          </template>
          <template slot="selected-option" slot-scope="option">
            <div class="selected d-center"> {{ option.text }} </div>
          </template>
        </v-select> 
      </p>

      <p class="setup__item">
        <span>Режим:</span>
        <v-select 
          @input="changeMode" 
          label="text" 
          :options="modes" 
          v-model="params.mode" 
          :reduce="option => option.id"
          :clearable="false"
        >
          <template slot="option" slot-scope="option">
            <div class="d-center"> {{ option.text }} </div>
          </template>
          <template slot="selected-option" slot-scope="option">
            <div class="selected d-center"> {{ option.text }} </div>
          </template>
        </v-select>
      </p>

      <p class="setup__item">
        <mode_params :params="params"></mode_params>
      </p>
    </div>    
</template>

<script>
import { texts_settings_mixin } from '../texts_settings_mixin'
import { modes_mixin } from '../modes_mixin'
import mode_params from "../mode_params";

export default {
  name: "settings",
  components: { mode_params },
  mixins: [texts_settings_mixin, modes_mixin],
  watch: {
    params: {
      handler: function (newValue) {
        if (!this.ingame) {
          this.$emit('params_changed', this.params);
        }
      },
      deep: true
    },
  },
  data() {
    return {
      params: {
        text_id: null,
        mode: null
      },
    }
  },
  props: {
    is_homework: '',
    ingame: ''
  },
  computed: {
    role() {
      return this.$store.state.user.role.code;
    },
  },
  methods: {
    changeMode() {
      console.log('change mode');
      let mode = this.params.mode;
      let selected_mode = _.filter(this.modes, (e) => {
        return e.id === mode;
      })[0];
      this.params.selected_mode = selected_mode;
    },
    scrollToSelectedText() {
      Vue.nextTick(() => {
        const active = this.$refs.select.$el.querySelector(".vs__dropdown-menu .vs__dropdown-option--selected");
        if (active) {
          active.scrollIntoView();
        }
      });
    }
  },
  mounted() {
    this.params = this.$store.state.train.texts_params;
    if (!this.params.selected_mode) this.params.selected_mode = this.modes[0];
  }
}
</script>
